var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIrdm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-390715f0-9934-4fbc-8974-4e1e7254c2fb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-9770cf39-c824-45f8-80eb-21eefb012da6{fill:#fff;}.uuid-4a33d680-09b9-4060-969c-d5320408c3c2{fill:#f2b207;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9770cf39-c824-45f8-80eb-21eefb012da6",
    x: -0.5,
    y: -0.5,
    width: 513,
    height: 513
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 75.89,
    cy: 158.61,
    r: 21.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 162.5,
    cy: 149.58,
    r: 21.39
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 225.24,
    cy: 209.58,
    r: 21.39
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 305.33,
    cy: 255.41,
    r: 21.39
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 305.33,
    cy: 330.89,
    r: 21.39
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 393.33,
    cy: 362.42,
    r: 21.39
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4a33d680-09b9-4060-969c-d5320408c3c2",
    cx: 436.11,
    cy: 288.96,
    r: 21.39
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIrdm);
export default __webpack_public_path__ + "static/media/icon_irdm.5e2f49bdc2b37ebd8f31cfe06c12641c.svg";
export { ForwardRef as ReactComponent };